import styled, { css } from "styled-components";
import { PopoverItemProps } from "./PopoverItem.types.js";

export const Wrapper = styled.div<Pick<PopoverItemProps, "isSelected" | "isHighlighted">>`
    display: flex;
    width: 100%;
    padding: ${(props) => `${props.theme.spacing[8]} ${props.theme.spacing[16]}`};
    cursor: pointer;
    transition: all 0.2s ease;
    overflow: hidden;
    text-overflow: ellipsis;

    &:hover {
        background-color: ${(props) => props.theme.grayscale[10]};
    }

    ${(props) =>
        props.isHighlighted &&
        css`
            background-color: ${props.theme.grayscale[20]};
        `}

    ${(props) =>
        props.isSelected &&
        css`
            background-color: ${props.theme.colors.primary[10]} !important;
            color: ${props.theme.colors.primary[100]};
        `}
`;
